"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _StyledTypography = require("../../../StyledTypography");

var _Elements = require("./Elements");

var NotFound = function NotFound() {
  return /*#__PURE__*/_react["default"].createElement(_Elements.StyledNotFoundWrapper, null, /*#__PURE__*/_react["default"].createElement(_Elements.StyledNotFoundBackground // eslint-disable-next-line max-len
  , {
    src: "https://drscdn.500px.org/photo/239425543/q%3D80_m%3D2000/v2?sig=2ea7c2f84fa64d30a10939bf510158e52575bac3bafca95e06ea1589dd8b8ee4",
    alt: "Not found"
  }), /*#__PURE__*/_react["default"].createElement(_Elements.StyledNotFoundInfo, null, /*#__PURE__*/_react["default"].createElement(_Elements.StyledNotFoundTitle, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.not_found.oops"
  })), /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingMedium, {
    my: "lg",
    bold: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.not_found.description"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.StyledPowerText, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.not_found.power_by",
    values: {
      link: /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://www.500px.com"
      }, "500px")
    }
  }))), /*#__PURE__*/_react["default"].createElement(_Elements.StyledNotFoundPhotograph, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.not_found.photo_by",
    values: {
      photographer: /*#__PURE__*/_react["default"].createElement("a", {
        style: {
          color: 'inherit'
        },
        href: "".concat(process.env.REACT_APP_BASE_URL, "/p/karenkhachaturov")
      }, "Karen Khachaturov")
    }
  })));
};

var _default = NotFound;
exports["default"] = _default;